import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const NAV = [
    { href: "#home", label: "Acasă" },
    { href: "#servicii", label: "Servicii" },
    { href: "#galerie", label: "Galerie" },
    { href: "#contact", label: "Contact" },
  ];

  const closeMenu = () => setOpen(false);

  return (
    <header className="sticky top-0 z-50 border-b bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        {/* Logo / Brand */}
        <a href="#home" aria-label="Curățătoria Deniadi" className="inline-flex items-center gap-3">
          <img
            src="/logo.png"
            alt="Curățătoria Deniadi"
            className="h-12 w-auto select-none md:h-14 lg:h-16"
            draggable="false"
          />
          <span className="text-xs font-semibold leading-tight text-slate-800 sm:text-sm">
            Curățătoria Deniadi
            <span className="hidden text-[11px] font-normal text-slate-500 sm:block">Timișoara</span>
          </span>
        </a>

        {/* Desktop nav */}
        <div className="hidden items-center gap-6 md:flex">
          <nav className="flex items-center gap-4 text-sm">
            {NAV.map((item) => (
              <a key={item.href} href={item.href} className="hover:text-slate-700">
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="tel:+40761686603"
            className="rounded-xl bg-sky-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-sky-700"
          >
            Sună: +40 761 686 603
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border hover:bg-slate-50 md:hidden"
          aria-label={open ? "Închide meniul" : "Deschide meniul"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? (
            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 6l12 12M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden border-t bg-white">
          <div className="mx-auto max-w-6xl px-4 py-3">
            <nav className="grid gap-2 text-sm">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={closeMenu}
                  className="rounded-lg px-3 py-2 hover:bg-slate-50"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <div className="mt-3">
              <a
                href="tel:+40761686603"
                onClick={closeMenu}
                className="block rounded-lg bg-sky-600 px-3 py-2 text-center text-sm font-medium text-white shadow-sm transition hover:bg-sky-700"
              >
                Sună: +40 761 686 603
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
